import React from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { Question } from "../../../../../models/question/question";
import { ScanValue } from "../../../../../models/scan-value/scanValue";
import { PolarData } from "../../../../../models/question/polarData";

export interface PolarTypeComponentProps {
  disabled?: boolean;
  question?: Question;
  scanValue?: ScanValue;
  setScanValue?: (value: ScanValue) => void;
}

export function PolarTypeComponent({
  question,
  scanValue,
  setScanValue,
  disabled = false,
}: PolarTypeComponentProps) {
  const q =
    !!scanValue && !!scanValue.question ? scanValue.question : question!;
  const polarData = q.data as PolarData;

  return (
    <FormControl component="fieldset" required={q.required} disabled={disabled}>
      <RadioGroup
        value={!!scanValue ? scanValue.value : null}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (!!scanValue && !!setScanValue) {
            const value = (event.target as HTMLInputElement).value;

            setScanValue({
              ...scanValue,
              value,
              score: value === "true" ? polarData.score : null,
            });
          }
        }}
      >
        <FormControlLabel disabled={disabled} value="true" control={<Radio disabled={disabled} />} label="Ja" />
        <FormControlLabel disabled={disabled} value="false" control={<Radio disabled={disabled} />} label="Nee" />
      </RadioGroup>
    </FormControl>
  );
}
